import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`

export const Profile = styled.img`
  width: 65px;
  height: 65px;
  border-radius: 100px;
`
export const WrapperHeader = styled.div`
  @media (min-width: 768px) {
    display: flex;
    -webkit-box-pack: center;
    justify-content: space-between;
    gap: 0px;
    margin: 0;
  }
`

export const DivCentral = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: ${theme.colors.white};
  font-weight: 800;
`
export const DivIconName = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  div {
    width: 100%;

    @media (min-width: 768px) {
      width: 300px;
    }

    .doctor-name {
      width: calc(100% - 53px);
    }
  }
`

export const SLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  font-weight: 500;
`

export const DivIcons = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  gap: 5px;
  @media (min-width: 768px) {
    position: absolute;
    top: 5%;
    right: 100px;
    display: flex;
    gap: 20px;
  }
`

export const Banner = styled.div`
  width: 75%;
  margin: 0 auto;
  margin-top: 50px;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const FirstBanner = styled.div`
  position: absolute;
  top: 130px;
  width: 95%;
  left: 10px;
  @media (min-width: 768px) {
    width: 65%;
    left: 18%;
    top: 90%;
  }
`

export const Content = styled.div`
  margin-top: 28%;
  @media (min-width: 768px) {
    margin-top: 17%;
  }
`

export const M = styled.div`
  margin: 8% 5%;

  @media (min-width: 768px) {
    margin: 5% 100px;
  }

  p {
    font-size: 12px;
    font-weight: 500;

    @media (min-width: 768px) {
      font-size: 14px;
    }
  }

  .card-container {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: 767px) {
      > :nth-child(n + 4) {
        display: none;
      }
    }

    @media (min-width: 768px) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: auto;
      gap: 48px;
    }
  }
`

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  font-weight: 700;
  font-size: 14px;

  @media (min-width: 768px) {
    span {
      font-size: ${theme.font.sizes.xxlarge};
    }
  }
`

export const Relative = styled.div`
  position: relative;
`

export const ImgFaq = styled.img`
  position: absolute;
  top: -34px;
  right: 16px;

  @media (min-width: 768px) {
    right: 100px;
  }
`
export const IconTag = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  width: 11px;
  height: 11px;

  border-radius: 50%;

  background-color: ${theme.colors.erro};

  right: 30px;

  @media (min-width: 768px) {
    right: 40px;
  }
`
